// extracted by mini-css-extract-plugin
module.exports = {"content":"banner-module--content--MJqjm","virtualshop":"banner-module--virtualshop--3oKRV","icon":"banner-module--icon--2el1E"};